import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-245" data-mp="o5hzekipto28">
      <div className="mx-auto max-w-4xl px-4" data-id="element-246" data-mp="j7ox42kj9e78">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-field sm:text-4xl" data-id="element-247" data-mp="j900w2dzalyc">Resumen final</h2>
        <p className="mt-3 text-center text-muted" data-id="element-248" data-mp="1gskz3fz4o4u2">
          {productName} · {totalVolumes} tomos + {totalBonuses} bonos · <b className="text-earth-dark" data-id="element-249" data-mp="16wrfxdqwld3b">{price}</b>
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-250" data-mp="16uy5dnd668q1">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 rounded-lg border border-line bg-white p-4 shadow-card" data-id="element-251" data-mp="12uwdu715evoh">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-field" data-id="element-252" data-mp="3rkvudkim2lq8">
                <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-253" data-mp="3nnrffsn0d79q" />
              </span>
              <p data-id="element-254" data-mp="3nbzb1oxjswh1">
                <b className="block text-sm text-ink" data-id="element-255" data-mp="3nciu58yxpqwn">{feature}</b>
                <span className="text-sm text-muted" data-id="element-256" data-mp="3n9wk92okmzb9">{detail}</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}